var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPortfolio2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666748,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#FF9D59"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1988_5122",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 20,
    width: 41,
    height: 40
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20.6667,
    y: 20,
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1988_5122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.6668 34.1946L35.2222 28.75L40.6668 23.3054L46.1114 28.75L40.6668 34.1946ZM22.3335 53.3333V46.6667C22.3335 45.8147 22.6321 45.0925 23.2293 44.5C23.8266 43.9075 24.5464 43.6113 25.3889 43.6113H31.1252C31.6252 43.6113 32.102 43.7363 32.5556 43.9863C33.0095 44.2363 33.3892 44.5788 33.6947 45.0138C34.5003 46.1526 35.5164 47.0369 36.7431 47.6667C37.97 48.2964 39.2779 48.6113 40.6668 48.6113C42.0649 48.6113 43.3774 48.2964 44.6043 47.6667C45.8313 47.0369 46.8521 46.1526 47.6668 45.0138C47.991 44.5788 48.3729 44.2363 48.8127 43.9863C49.2524 43.7363 49.7177 43.6113 50.2085 43.6113H55.9447C56.7964 43.6113 57.5186 43.9075 58.1114 44.5C58.7039 45.0925 59.0002 45.8147 59.0002 46.6667V53.3333H47.8889V48.7638C46.8984 49.6065 45.785 50.2547 44.5489 50.7083C43.3128 51.1619 42.0188 51.3888 40.6668 51.3888C39.3243 51.3888 38.0372 51.1596 36.8056 50.7013C35.5742 50.2429 34.4539 49.5925 33.4447 48.75V53.3333H22.3335ZM27.3335 41.1113C26.0371 41.1113 24.926 40.6482 24.0002 39.7221C23.0743 38.7963 22.6114 37.6851 22.6114 36.3888C22.6114 35.0649 23.0743 33.9468 24.0002 33.0346C24.926 32.1226 26.0371 31.6667 27.3335 31.6667C28.6577 31.6667 29.7757 32.1226 30.6877 33.0346C31.5996 33.9468 32.0556 35.0649 32.0556 36.3888C32.0556 37.6851 31.5996 38.7963 30.6877 39.7221C29.7757 40.6482 28.6577 41.1113 27.3335 41.1113ZM54.0002 41.1113C52.7038 41.1113 51.5927 40.6482 50.6668 39.7221C49.741 38.7963 49.2781 37.6851 49.2781 36.3888C49.2781 35.0649 49.741 33.9468 50.6668 33.0346C51.5927 32.1226 52.7038 31.6667 54.0002 31.6667C55.3243 31.6667 56.4424 32.1226 57.3543 33.0346C58.2663 33.9468 58.7222 35.0649 58.7222 36.3888C58.7222 37.6851 58.2663 38.7963 57.3543 39.7221C56.4424 40.6482 55.3243 41.1113 54.0002 41.1113Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolio2);
export default __webpack_public_path__ + "static/media/portfolio2.0b73733b47fff3d51969e02232f9c4ef.svg";
export { ForwardRef as ReactComponent };